import React from 'react';
import Svg from '../Svg';

import { IconProps } from '../icon';

export const Home18 = ({
  accessibilityLabel,
  contrast,
  className,
}: IconProps) => (
  <Svg
    accessibilityLabel={accessibilityLabel}
    size={18}
    contrast={contrast}
    className={className}
  >
    <g clipPath='url(#clip0_1_591)'>
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M8.1111 1.09776C8.60641 0.640183 9.39364 0.640182 9.88895 1.09776C9.89646 1.1047 9.90383 1.11179 9.91105 1.11903L17.531 8.75903L16.469 9.8183L15.7499 9.09734V15.7886C15.7499 16.4695 15.1808 17.0386 14.4999 17.0386H3.51636C2.83552 17.0386 2.26636 16.4695 2.26636 15.7886V9.08106L1.53104 9.8183L0.468994 8.75903L8.089 1.11903C8.09622 1.11179 8.10359 1.1047 8.1111 1.09776ZM7.75 15.5386H10.25V13.2886C10.25 12.6078 9.68083 12.0386 9 12.0386C8.31917 12.0386 7.75 12.6078 7.75 13.2886V15.5386ZM11.75 15.5386V13.2886C11.75 11.7908 10.4978 10.5386 9 10.5386C7.50217 10.5386 6.25 11.7908 6.25 13.2886V15.5386H3.76636V7.57712L9.00002 2.32972L14.2499 7.5934V15.5386H11.75Z'
        fill='currentColor'
      />
    </g>
    <defs>
      <clipPath id='clip0_1_591'>
        <rect width='18' height='18' fill='white' />
      </clipPath>
    </defs>
  </Svg>
);

Home18.displayName = 'Home18';
export default Home18;
